export const toggleKioskQueryParam = (isKioskMode, navigate) => {
  const searchParams = new URLSearchParams(window.location.search);

  if (isKioskMode) {
    searchParams.set("kiosk", "true");
  } else {
    searchParams.delete("kiosk");
  }

  const newUrl = {
    pathname: window.location.pathname,
    search: searchParams.toString(),
  };

  navigate(newUrl, { replace: true });
};

export const mobileCheck = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};

export const isVersionHigher = (oldVersion, newVersion) => {
  const oldParts = oldVersion.split(".").map(Number);
  const newParts = newVersion.split(".").map(Number);

  const maxLength = Math.max(oldParts.length, newParts.length);

  for (let i = 0; i < maxLength; i++) {
    const oldVal = oldParts[i] ?? 0; // Use 0 if undefined
    const newVal = newParts[i] ?? 0;

    if (newVal > oldVal) return true;
    if (newVal < oldVal) return false;
  }

  return false; // Versions are equal
};
